module.exports = __webpack_public_path__ + "img/portfoliosite.13615b36.png";